import React from "react";
import { RiskMethodologyModal } from "./RiskMethodologyModal";
import { RISK_METHODOLOGY } from "./riskMethodologyContent";
import { PORTFOLIO_METHODOLOGY } from "./portfolioMethodologyContent";

/**
 * PortfolioMethodologyModal — "how to read this board" reference for the Portfolio (book
 * of record) page. Reuses the shared RiskMethodologyModal renderer with Portfolio copy
 * (portfolioMethodologyContent.ts).
 *
 * Portfolio was the only board in the app with NO methodology layer and no inline hints —
 * which mattered more here than elsewhere, because the page carries two denominators, a
 * plug row whose absence is not a tie-out, a rank that is not a level, and a cap that is a
 * purchase constraint rather than a holding limit. Every one of those was a live source of
 * misreading before this existed.
 *
 * Presentation only: it renders grounded copy in tabs and never fetches, computes or
 * mutates anything.
 */
export const PortfolioMethodologyModal: React.FC<{ open: boolean; onClose: () => void }> = ({
  open,
  onClose,
}) => (
  <RiskMethodologyModal
    open={open}
    onClose={onClose}
    content={PORTFOLIO_METHODOLOGY as unknown as typeof RISK_METHODOLOGY}
    titleId="portfolio-methodology-title"
  />
);

export default PortfolioMethodologyModal;
